var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showMessage)?_c('div',{on:{"contextmenu":function($event){$event.preventDefault();return _vm.openMenu($event, _vm.message)}}},[_c('div',{class:_vm.message.belong ? 'text-body-my' : 'text-body'},[_c('video',{staticStyle:{"width":"200px"},attrs:{"src":_vm.message.messageUrl,"controls":"controls"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }